import { ApiUnmanage } from "../api-wrapper/campaign/ApiCampaignName"
import { campaignsTypeEnum } from "../modules/sponsoredProductsSKCAntd/types/types"

const unmanageSponsoredProductCampaigns = (campaignIdsForUnmanage) => {
  const data = {
    isManage: false,
    campaignIds: campaignIdsForUnmanage,
    type: campaignsTypeEnum.SPONSORED_PRODUCTS,
  }

  return ApiUnmanage(data)
}

export default {
  unmanageSponsoredProductCampaigns,
}
